<div class="blockCardContainer" [routerLink]="['/event/'] + key">
    <div class="imageContainer">
        <img [defaultImage]="defaultImage" [lazyLoad]="image">
    </div>
    <div class="contentContainer">
        <h1>{{ title }}</h1>
        <h3 style="margin-top: 5px;">{{ subTitle }}</h3>
    </div>
</div>